import { useDefaultModuleActions } from "../../common"
import { newId } from "../../../features/data-types"
import { DynamoUserApi } from "../../../services"
import { TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { Settings, SettingsDataType, SettingsModule, useAdministrationActions, useSettingsLoaders } from "../../administration"
import { useProductsActions } from "../../products"
import { useSystemStateHooks } from "../../system"
import { Supplier } from "../state/types"

export const usePurchasesActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const settingsLoaders = useSettingsLoaders()

    const defaultModuleActions = useDefaultModuleActions()
    const administrationActions = useAdministrationActions()
    const productsActions = useProductsActions()

    return (paramCompanyId?: string) => {
        const companyId = paramCompanyId || stateCompanyId
        const { fetchAll, save, saveMultiple, remove } = defaultModuleActions(DynamoUserApi, define(companyId))
        const { saveCategory, removeCategory, saveProductPrices } = productsActions(companyId)
        const { saveSettings } = administrationActions(companyId)

        const savePurchasesSetting = async (propName: string, value: SettingsDataType) => {
            const { findModuleSettings } = settingsLoaders(companyId)
            const settings = findModuleSettings(SettingsModule.PURCHASES)
            const updatedSettings: Settings = settings ? {
                ...settings,
                [propName]: value
            } : {
                companyId: define(companyId),
                id: newId(),
                module: SettingsModule.PURCHASES,
                [propName]: value
            }
            
            return await saveSettings(updatedSettings) as Settings
        }

        const fetchAllSuppliers = async () => {
            return fetchAll(TableName.SUPPLIERS) as Promise<Supplier[]>
        }

        return {
            savePurchasesSetting,
            fetchAllSuppliers,
            saveCategory,
            removeCategory,
            saveProductPrices
        }
    }
}
